export default __webpack_public_path__ + "static/media/4-ms-machine-frame-fabrication.b96fe58e.webp";